<template>
  <div class="home">
    <Navbar />
    <home-top />
    <home-main />
    <Footer />
  </div>
</template>

<script>
// import { BContainer } from 'bootstrap-vue'
import Navbar from './component/Navbar.vue'
import Footer from './component/Footer.vue'
import HomeTop from './HomeTop.vue'
import HomeMain from './HomeMain.vue'

export default {
  title: '',
  components: {
    Navbar,
    Footer,
    HomeTop,
    HomeMain,
  },
  data() {
    return {
    }
  },
  setup() {
    const href = window.location.origin
    window.history.replaceState(href, 'about', '/about.html')
  },

}
</script>

<style lang="scss" scoped>
.home {
  position: relative;
  background-color: #0c0c0c;
}
</style>
